const state = {
cuponData: {
	detail: [],
	validate: null
},
couponTextValidate: ''
};

const getters = {};

const actions = {};

const mutations = {
SetCuponData(state, data) {
	state.cuponData.detail = data.detail;
	state.cuponData.validate = data.validate;
},
SetCouponText(state, data) {
	state.couponTextValidate = data;
}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
